export default theme => ({
  creditCardGroup: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  },
  formAndButton: {
    width: '100%',
    flexDirection: 'column'
  },
  frameClass: {
    height: '54px !important',
    borderRadius: '8px !important',
    backgroundColor: theme.neutral[400],
    padding: [0, 0, 0, 16],
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& > div': {
      width: '100%'
    }
  },
  encryptedCardNumber: {
    flex: '100%',
    margin: '0 0 16px 0'
  },
  encryptedExpiryDate: {
    flex: 1,
    margin: '0 16px 0 0'
  },
  encryptedSecurityCode: {
    flex: 1
  },
  encryptedCardNumberExtraClass: {
    border: ({ encryptedCardNumber }) => `1px ${!encryptedCardNumber?.empty && encryptedCardNumber?.message !== undefined ? theme.error[0] : theme.neutral[0]} solid !important`
  },
  encryptedExpiryDateExtraClass: {
    border: ({ encryptedExpiryDate }) => `1px ${!encryptedExpiryDate?.empty && encryptedExpiryDate?.message !== undefined ? theme.error[0] : theme.neutral[0]} solid !important`
  },
  encryptedSecurityCodeExtraClass: {
    border: ({ encryptedSecurityCode }) => `1px ${!encryptedSecurityCode?.empty && encryptedSecurityCode?.message !== undefined ? theme.error[0] : theme.neutral[0]} solid !important`
  }
})
